<app-tooltip-template label="select.channel" *ngIf="params.hasOwnProperty('channel')">
  {{ params.channel?.attributes.name || ('select.all_channel' | translate)  }}
</app-tooltip-template>
